// import { useCallback } from "react";
import { useShallow } from 'zustand/react/shallow'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
// import type { LiveGiftsAnimations } from "../../../types/lives/animations";
import type { NotifyRocketGameExploded } from '../../../types/lives/notifies'

const LIVE_ROCKET_GAME = '/LIVE-ROCKET-GAME'

export const useUpdateToastRocketGame = () => {
  const { liveCountry, addNotifyRocketGame } = useGlobalStore(
    useShallow((state) => ({
      liveCountry: state.liveCountry,
      addNotifyRocketGame: state.addNotifyRocketGame,
    })),
  )

  useSub<NotifyRocketGameExploded>({
    endpoint: `${LIVE_ROCKET_GAME}/${liveCountry}`,
    skip: !liveCountry,
    onData: (data) => {
      if ('ReactNativeWebView' in window) {
        // @ts-ignore
        window.ReactNativeWebView.postMessage('show')
        // @ts-ignore
        window.ReactNativeWebView.postMessage(data?.liveId)
      }

      addNotifyRocketGame(data)
    },
  })
}
